import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useIdentityManager } from '../../../common/hooks/useIdentityManager';
import useClickOutside from '../../../common/hooks/useClickOutside';
import useTranslate from '../../../common/hooks/useTranslate';
import { hasBoards } from '../../../common/services/http/analysisContentService';
// @ts-ignore
import LogoNav from '../../../assets/images/logoNav.svg';

import './responsiveNavigation.scss';

interface INavigation {
  setNav: (state: boolean) => void;
  id?: string;
}

const ResponsiveNavigation: React.FC<INavigation> = ({ setNav, id }) => {
  const [showBoards, setShowBoards] = useState(true);
  const identity = useIdentityManager();
  const wrapperRef = useRef(null);
  const { t } = useTranslate();

  const clickOutsideHandler = () => {
    setNav(false);
  };

  useClickOutside(wrapperRef, clickOutsideHandler, id);

  useEffect(() => {
    hasBoards().then((r) => {
      setShowBoards(r.hasBoards);
    });
  }, []);

  return (
    <div className='responsive-nav' ref={wrapperRef}>
      <NavLink end to='/' className={({ isActive }) => (isActive ? `active-link` : ``)} onClick={() => setNav(false)}>
        <button className='responsive-nav-btn'>
          <div>
            {t('NAVIGATION.HOME')}
          </div>
        </button>
      </NavLink>
      {showBoards && (
        <NavLink to='/boards' className={({ isActive }) => (isActive ? `active-link` : ``)}
                 onClick={() => setNav(false)}>
          <button className='responsive-nav-btn'>
            <div>
              {t('NAVIGATION.BOARDS')}
            </div>
          </button>
        </NavLink>
      )}
      <NavLink to='/documents' className={({ isActive }) => (isActive ? `active-link` : ``)}
               onClick={() => setNav(false)}>
        <button className='responsive-nav-btn'>
          <div>
            {t('NAVIGATION.DOCUMENTS')}
          </div>
        </button>
      </NavLink>
      <NavLink to='/docusign/sign' className={({ isActive }) => (isActive ? `active-link` : ``)}
               onClick={() => setNav(false)}>
        <button className='responsive-nav-btn navigation-docusign'>
          <div>
            {t('NAVIGATION.DOCUSIGN')}
          </div>
        </button>
      </NavLink>
      <NavLink to='/profile' className={({ isActive }) => (isActive ? `active-link` : ``)}
               onClick={() => setNav(false)}>
        <button className='responsive-nav-btn'>
          <div>
            {t('NAVIGATION.PROFILE')}
          </div>
        </button>
      </NavLink>

      <button className='responsive-nav-btn sign-out-btn' onClick={() => identity.signOut()}>
        <div>
          {t('NAVIGATION.LOGOUT')}
        </div>
      </button>
      <img src={LogoNav} className="company-logo" alt={"CapInteract Logo"}/>
    </div>
  );
};

export default ResponsiveNavigation;
